import * as React from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { ManufacturerList } from '@/components/sensory'
import { AddManufacturerComposer } from '@/forms/sensory'
import { Button } from '@/components/ui/button'
import { ArrowLeft } from 'lucide-react'
import { useToast } from '@/contexts/ToastContext'

type View = 'list' | 'create'

function ManufacturersPage() {
  const { toast } = useToast()
  const [view, setView] = React.useState<View>('list')
  const [listKey, setListKey] = React.useState(0)

  const handleAdd = () => {
    setView('create')
  }

  const handleBack = () => {
    setView('list')
  }

  const handleCreateSuccess = () => {
    toast({ title: 'Success', description: 'Manufacturer created successfully.', type: 'success' })
    setListKey((k) => k + 1)
    setView('list')
  }

  const handleError = (error: Error) => {
    toast({ title: 'Error', description: error.message, type: 'error' })
  }

  if (view === 'create') {
    return (
      <div className="p-6 space-y-4">
        <Button variant="ghost" className="gap-2" onClick={handleBack}>
          <ArrowLeft className="h-4 w-4" />
          Back to Manufacturers
        </Button>
        <AddManufacturerComposer
          onSuccess={handleCreateSuccess}
          onError={handleError}
          onCancel={handleBack}
        />
      </div>
    )
  }

  return (
    <div className="p-6">
      <ManufacturerList
        key={listKey}
        onAdd={handleAdd}
      />
    </div>
  )
}

export const Route = createFileRoute("/sensory/manufacturers/")({
  staticData: {
    title: 'Manufacturers',
    isSecured: true,
  },
  component: ManufacturersPage,
})
